import React from 'react';
import { ApolloError } from '@apollo/client';
import { Stack } from '@mui/material';

import { Divider, Card, CardContent } from '@occc/ui-design-system';
import { LocationFragment, MembershipFragment, PhoneNumberMetadataFragment } from '@occc/graphql';
import { MemberPhoneNumberMetadata } from '@occc-app/routes/Member/MemberDetailsPage/components/MemberDetails/MemberPhoneNumberMetadata';

import MemberDetailsFields from './MemberDetailsFields';
import { MemberLocations } from './MemberLocations';
import MemberPrimaryAddressFields from './MemberPrimaryAddressFields';

export type MemberDetailsProps = {
  member: MembershipFragment;
  locations?: LocationFragment[];
  locationsError?: ApolloError;
  locationsLoading: boolean;
  phoneNumberMetadata?: PhoneNumberMetadataFragment;
  isPhoneNumberMetadataLoading: boolean;
  isPhoneNumberMetadataError?: ApolloError;
};

const MemberDetails = ({
  member,
  locations,
  locationsLoading,
  locationsError,
  phoneNumberMetadata,
  isPhoneNumberMetadataLoading,
  isPhoneNumberMetadataError,
}: MemberDetailsProps) => {
  return (
    <Card sx={{ mb: 0 }}>
      <CardContent>
        <Stack spacing={1} divider={<Divider />}>
          <MemberDetailsFields member={member} />
          {member.primaryAddress && <MemberPrimaryAddressFields address={member.primaryAddress} />}
          <MemberLocations
            locations={locations}
            locationsLoading={locationsLoading}
            locationsError={locationsError}
          />
          <MemberPhoneNumberMetadata
            phoneNumberMetadata={phoneNumberMetadata}
            isPhoneNumberLoading={isPhoneNumberMetadataLoading}
            isPhoneNumberMetadataError={isPhoneNumberMetadataError}
          />
        </Stack>
      </CardContent>
    </Card>
  );
};

export default MemberDetails;
